/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthBarberLoginInput } from "../../entities/models/AuthBarberLoginInput";
import { z } from "zod/v4";

export const modelsAuthBarberLoginInputSchema = z.object({
    "phone": z.string(),
"pin_code": z.string().min(6).max(6)
    }) as unknown as z.ZodType<ModelsAuthBarberLoginInput>